"use client";

import { Provider, ErrorBoundary } from "@rollbar/react";
import { rollbarClientConfig } from "@/lib/rollbar";

export function RollbarProvider({ children }: { children: React.ReactNode }) {
  return (
    <Provider config={rollbarClientConfig}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Provider>
  );
}
